import React, { FC, useState } from 'react';

import Accordion, { AccordionItem } from '@adsk/alloy-react-accordion';

import { VariantProps } from './variants';
import ReferencePickerBlockGroup from '../blocks/ReferencePickerBlockGroup';
import ReferencePickerBlockTitle from '../blocks/ReferencePickerBlockTitle';
import getPluginKey from '../helpers/getPluginKey';

export const AccordionVariant: FC<VariantProps> = ({
  groupData,
  allowRemoveLinkedEntity,
  setDataToConfirmRemoving,
  updateEntitiesInCache,
  onReferenceClickAnalytics,
  sourceEntityId,
  sourceEntityDomain,
  sourceEntityType,
}) => {
  const [pluginCollapsed, setPluginCollapsed] = useState<
    Record<string, boolean>
  >({});

  return (
    <Accordion multiExpand={true} data-testid="reference-picker-accordion">
      {groupData.map(({ plugin, entityCache, relationships }) => {
        const { PluralText } = plugin;
        const pluginKey = getPluginKey(plugin);

        return (
          <AccordionItem
            expanded={!pluginCollapsed[pluginKey]}
            onExpand={() =>
              setPluginCollapsed((prev) => ({
                ...prev,
                [pluginKey]: !prev[pluginKey],
              }))
            }
            key={pluginKey}
            style={{
              margin: '0',
            }}
            title={
              <ReferencePickerBlockTitle isAccordionVariant>
                <PluralText /> <>({relationships.length})</>
              </ReferencePickerBlockTitle>
            }
          >
            <ReferencePickerBlockGroup
              plugin={plugin}
              relationships={relationships}
              entitiesCache={entityCache}
              allowRemoveLinkedEntity={allowRemoveLinkedEntity}
              setDataToConfirmRemoving={setDataToConfirmRemoving}
              updateEntitiesInCache={updateEntitiesInCache}
              onReferenceClickAnalytics={onReferenceClickAnalytics}
              sourceEntityId={sourceEntityId}
              sourceEntityDomain={sourceEntityDomain}
              sourceEntityType={sourceEntityType}
              isAccordionVariant
            />
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
